import { ReferenceImage } from '../../../services/imageGenerationApi';

export interface GeneratedImage {
  url: string;
  prompt: string;
  seed: number;
  index: number;
  provider?: 'runway' | 'sdxl' | 'banana_nano';
  loading?: boolean;
}

export const getSelectedVideoImage = (
  videoImageSource: 'generated' | 'library' | 'upload',
  generatedImages: GeneratedImage[] | null,
  selectedImageIndex: number,
  referenceImages: ReferenceImage[]
) => {
  // Auto-detect source if the current source doesn't have images
  if (videoImageSource === 'generated' && generatedImages && generatedImages.length > 0) {
    return generatedImages[selectedImageIndex];
  } else if ((videoImageSource === 'library' || videoImageSource === 'upload') && referenceImages.length > 0) {
    // Use the first reference image for video generation
    const refImage = referenceImages[0];
    return {
      url: refImage.url || refImage.uri,
      prompt: `Library image: ${refImage.name || 'Reference'}`,
      seed: 0,
      index: 0
    };
  } else if (referenceImages.length > 0) {
    // Fallback: if no valid source but we have reference images, use them
    const refImage = referenceImages[0];
    return {
      url: refImage.url || refImage.uri,
      prompt: `Library image: ${refImage.name || 'Reference'}`,
      seed: 0,
      index: 0
    };
  } else if (generatedImages && generatedImages.length > 0) {
    // Fallback: if no valid source but we have generated images, use them
    return generatedImages[selectedImageIndex];
  }
  return null;
};
